export default "__VITE_ASSET__9e97cb03__"